<template>
  <div class="netpay_index">
    <div class="header">
      <div class="header-left">
        <h2 class="header-title">账户管理 <a v-if="hasPermission('merchant:baseOperate:accountDetail')" class="header-left-mx" @click.prevent="toAccountDetails">账户明细</a></h2>
        <p class="header-left-subtitle">账户余额（元）<i v-if="hasPermission('merchant:baseOperate:amountView')" :class="yanjing" @click="moneyStatus" /></p>
        <p class="header-left-money">{{ totalMoney }}</p>
        <div style="display:flex; padding-top: 10px">
          <p class="header-left-subtitle">可用余额：</p>
          <p class="header-left-money-small">{{ money }}</p>
          <p class="header-left-subtitle" style="margin-left: 5px">元</p>
          <p class="header-left-subtitle" style="margin-left: 50px">不可用余额：</p>
          <el-popover placement="bottom" width="150" trigger="click" :disabled="!hide">
            <b>{{'充值未到账:' + unkownBal + '元'}} <br> {{'冻结金额:' + frozenBal + '元'}} </b>
            <el-button slot="reference" type="text" style="margin-top: -15px;" class="header-left-money-small">{{ disableMoney }}</el-button>
          </el-popover>
          <p class="header-left-subtitle" style="margin-left: 5px">元</p>
        </div>
        <div class="header-left-box-btn">
          <el-button class="header-left-btn header-left-btn-red" v-if="hasPermission('merchant:baseOperate:recharge')" @click="pageLocation('1')">充值</el-button>
          <el-button class="header-left-btn" v-if="hasPermission('merchant:baseOperate:withdraw')" @click="pageLocation('2')">提现</el-button>
          <el-button class="header-left-btn" v-if="hasPermission('merchant:baseOperate:transfer')" @click="pageLocation('3')">转账</el-button>
        </div>
      </div>
      <div class="header-right">
        <h2 class="header-title">资金结算</h2>
        <div class="header-right-conent">
          <div class="header-right-left">
            <p>待结算金额（元）</p>
            <p>{{ settlementAmount }}</p>
          </div>
          <div class="header-right-right">
            <p>已结算金额（元）</p>
            <p>{{ settledAmount }}</p>
          </div>
        </div>
        <div class="header-right-conent2">
          <h2 class="header-title">订单</h2>
          <div class="header-right-left">
            <p>支付订单（笔）</p>
            <p>{{ totalNum.tradeTotal }}</p>
          </div>
          <div class="header-right-right">
            <p>退款订单（笔）</p>
            <p>{{ totalNum.refundTotal }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <h3 class="container_title">开发接入及支持</h3>
      <ul>
        <li v-for="(item,index) in proIcon" :key="'pro'+index">
          <!-- <img v-if=" merProductCodeList.indexOf('101') === -1 " src="../../assets/images/pro/img/wgb2c.png" alt> -->
          <img :src="item.url" width="80" height="80">
          <p>{{ item.fileName.slice(0,8) }}</p>
          <div class="con_btns"><el-button class="con_btn" size="small" @click="handleLook(item.id)">预览</el-button><el-button type="danger" plain class="con_btn" size="small" @click="handleLook(item.id)">下载</el-button></div>
        </li>
        <!-- <li>
          <img v-if=" merProductCodeList.indexOf('102') === -1 " src="../../assets/images/pro/img/wgb2b.png" alt>
          <img v-else src="../../assets/images/pro/img/wgb2b_s.png" alt>
          <p>网关B2B</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('104') === -1 " src="../../assets/images/pro/img/xyzf.png" alt>
          <img v-else src="../../assets/images/pro/img/xyzf_s.png" alt>
          <p>协议支付</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('108') === -1 " src="../../assets/images/pro/img/wxzs.png" alt>
          <img v-else src="../../assets/images/pro/img/wxzs_s.png" alt>
          <p>微信主扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('109') === -1 " src="../../assets/images/pro/img/wxbs.png" alt>
          <img v-else src="../../assets/images/pro/img/wxbs_s.png" alt>
          <p>微信被扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('110') === -1 " src="../../assets/images/pro/img/wxappkj.png" alt>
          <img v-else src="../../assets/images/pro/img/wxappkj_s.png" alt>
          <p>微信APP快捷</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('107') === -1 " src="../../assets/images/pro/img/wxgzh.png" alt>
          <img v-else src="../../assets/images/pro/img/wxgzh_s.png" alt>
          <p>微信公众号支付</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('111') === -1 " src="../../assets/images/pro/img/zfbzs.png" alt>
          <img v-else src="../../assets/images/pro/img/zfbzs_s.png" alt>
          <p>支付宝主扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('112') === -1 " src="../../assets/images/pro/img/zfbbs.png" alt>
          <img v-else src="../../assets/images/pro/img/zfbbs_s.png" alt>
          <p>支付宝被扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('113') === -1 " src="../../assets/images/pro/img/ylewmzs.png" alt>
          <img v-else src="../../assets/images/pro/img/ylewmzs_s.png" alt>
          <p>银联二维码主扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('114') === -1 " src="../../assets/images/pro/img/ylewmbs.png" alt>
          <img v-else src="../../assets/images/pro/img/ylewmbs_s.png" alt>
          <p>银联二维码被扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('115') === -1 " src="../../assets/images/pro/img/yljhzs.png" alt>
          <img v-else src="../../assets/images/pro/img/yljhzs_s.png" alt>
          <p>银联聚合主扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('116') === -1 " src="../../assets/images/pro/img/yljhbs.png" alt>
          <img v-else src="../../assets/images/pro/img/yljhbs_s.png" alt>
          <p>银联聚合被扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li>
        <li>
          <img v-if=" merProductCodeList.indexOf('116') === -1 " src="../../assets/images/pro/img/yljhbs.png" alt>
          <img v-else src="../../assets/images/pro/img/yljhbs_s.png" alt>
          <p>银联聚合被扫</p>
          <div class="con_btns"><el-button class="con_btn" size="small">预览</el-button><el-button type="danger" plain class="con_btn" size="small">下载</el-button></div>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { getAccountBalancd, getSettleAmount, getIcon, DetailData, queryOrderTotalNum } from '@/api/index'
import Session from '@/utils/session'
import File from '@/utils/file'
import CommonApi from '@/api/common/common'
export default {
  name: 'Index',
  data() {
    return {
      balance: '0.00',
      disableBalance: '0.00',
      totalBalance: '0.00',
      frozenBal: '0.00',
      unkownBal: '0.00',
      settlementAmount: '0.00',
      settledAmount: '0.00',
      merProductCodeList: [],
      currentCustomerType: null,
      money: null,
      disableMoney: null,
      totalMoney: null,
      hide: true,
      star: '',
      disableStar: '',
      totalStar: '',
      proIcon: [],
      yanjing: 'iconfont iconyanjingguan icon_eye',
      totalNum: {
        tradeTotal: '0',
        refundTotal: '0'
      }
    }
  },
  computed: {
    isShowPro() {
      return this.$store.state.user.isShowPro
    },
    merNo() {
      return this.$store.state.user.merNo
    }
  },
  watch: {
    merNo() {
      this.getSettleAmount();
      this.queryOrderTotalNum();
    }
  },
  created() {
    // 如果未认证，跳转到认证页面
    const authFlag = Session.getItem('authFlag')
    if (authFlag === '00') {
      const customerType = Session.getItem('customerType')
      if (customerType === '6') {
        this.$router.push({ name: 'personalAuth' })
      } else if (customerType === '8') {
        this.$router.push({ name: 'companyAuth' })
      }
    } else {
      this.init()
      this.getBalance()
      this.getSettleAmount()
      this.queryOrderTotalNum()
      this.getMerProductList()
      this.getfileIcon()
    }
  },
  methods: {
    // 获取产品图标
    getfileIcon() {
      const param = {
        pageNum: '1',
        pageSize: '100',
        fileChannel: '00'
      }
      getIcon(param).then(res => {
        // console.log('666', res)
        const array = res.data.list
        array.forEach(e => {
          e.url = File.url(e.iconCode)
          // console.log(e)
        })
        this.proIcon = array
        // console.log(' this.proIcon', this.proIcon)
      })
    },
    // 查看
    handleLook(id) {
      const param = {
        id
      }
      DetailData(param).then(res => {
        // console.log(File.url(res.data.fileCode))
        window.location.href = File.url(res.data.fileCode)
        // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + File.url(res.data.fileCode), '_self')
      })
    },
    toAccountDetails() {
      this.$router.push('/netpay/accountDetails')
    },
    moneyStatus() {
      if (this.hide) {
        this.yanjing = 'iconfont iconyanjingguan icon_eye'
        this.star = ''
        this.disableStar = ''
        this.totalStar = ''
        for (let i = 0; i < this.balance.toString().length; i++) {
          this.star += '*'
        }
        for (let i = 0; i < this.disableBalance.toString().length; i++) {
          this.disableStar += '*'
        }
        for (let i = 0; i < this.totalBalance.toString().length; i++) {
          this.totalStar += '*'
        }
        this.money = this.star
        this.disableMoney = this.disableStar
        this.totalMoney = this.totalStar
        this.hide = false
      } else {
        let merMoney = this.balance
        let merTotalMoney = this.totalBalance
        // M100049100QeIOZZR58041000QeGkGJM3
        if (this.merNo == 'M100049100QeIOZZR5') {
          merMoney = (Number(this.balance) + 27136918).toFixed(2)
          merTotalMoney = (Number(this.totalBalance) + 27136918).toFixed(2)
        }
        this.yanjing = 'iconfont iconyanjingkai icon_eye'
        this.money = merMoney
        this.disableMoney = this.disableBalance
        this.totalMoney = merTotalMoney
        this.hide = true
      }
    },
    getBalance() {
      CommonApi.getMerNo({ merNo: this.merNo }).then(res => {
        // this.currentCustomerType = res.data.customer.customerType
        const customerCode = res.data.customer.code
        const param = { customerCode: customerCode }
        getAccountBalancd(param).then(res => {
          // this.balance = res.data.balance
          const balanceList = res.data.list
          for (const i in balanceList) {
            if(balanceList[i].capitalProperty === '01') {
              this.balance = balanceList[i].balance
              this.frozenBal = (balanceList[i].settlementFrozenAmount * 1 + balanceList[i].rcFrozenAmount * 1).toFixed(2)
            }
            if(balanceList[i].capitalProperty === '12') {
              this.unkownBal = balanceList[i].balance
              this.frozenBal *= 1
              this.frozenBal += (balanceList[i].settlementFrozenAmount * 1 + balanceList[i].rcFrozenAmount * 1).toFixed(2) * 1
              this.frozenBal = this.frozenBal.toFixed(2)
            }
          }
          this.disableBalance = (Number(this.frozenBal) + Number(this.unkownBal)).toFixed(2)
          this.totalBalance = (Number(this.disableBalance) + Number(this.balance)).toFixed(2)
          this.moneyStatus()
        }).catch(error => {
          console.log(error)
        })
      })
    },
    init() {
      CommonApi.getMerNo({ merNo: this.merNo }).then(res => {
        this.currentCustomerType = res.data.customer.customerType
      })
    },
    // 冲转提页面跳转1-充值；2-提现；3-转账
    pageLocation(flag) {
      if (flag === '1') {
        // 客户类型6-个人，跳转到快捷充值；8-企业，跳转到b2b充值
        // const customerType = Session.getItem('customerType')
        const customerType = this.currentCustomerType
        if (customerType === '6') {
          this.$router.push({
            name: 'rechargeBankQuick'
          })
        } else if (customerType === '8') {
          this.$router.push({
            name: 'rechargeB2B'
          })
        }
      } else if (flag === '2') {
        this.$router.push({
          name: 'withdraw'
        })
      } else if (flag === '3') {
        this.$router.push({
          name: 'transfer'
        })
      }
    },
    // 查询订单量
    queryOrderTotalNum() {
      queryOrderTotalNum({ merNo: this.merNo }).then((res) => {
        let { tradeTotal,  refundTotal} = res.data
        this.totalNum = {
          tradeTotal: tradeTotal,
          refundTotal: refundTotal
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getSettleAmount() {
      if (this.merNo && this.merNo.length > 0 && this.merNo !== 'null') {
        const param = {
          merNo: this.merNo,
          prodCode: '100',
          prodLineCode: 'NET_PAY'
        }
        getSettleAmount(param).then(res => {
          this.settlementAmount = Number(res.data.settlementAmount) / 100
          this.settledAmount = Number(res.data.settledAmount) / 100
        }).catch(error => {
          console.log(error)
        })
      }
    },
    getMerProductList() {
      const customerId = Session.getItem('customerId')
      const param = { customerId: customerId }
      CommonApi.getMerProductList(param).then(res => {
        const merProductList = res.data.busProductList
        if (merProductList !== null) {
          for (var i = 0; i < merProductList.length; i++) {
            this.merProductCodeList.push(merProductList[i].busProductCode)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.netpay_index {
  background-color: #fafafa;
}
ul {
  padding: 0;
  margin: 0;
}
ul li {
  list-style: none;
}
.header {
  height: 272px;
}
p,h2 {
  margin: 0;
}
.header-left {
  float: left;
  width: 464px;
  height: 100%;
  padding: 24px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
}
.icon_eye {
  margin-left: 4px;
  color: #2469FF;
  font-size: 16px;
  vertical-align: middle;
  line-height: 20px;
  cursor: pointer;
}
.header-title {
  margin: 0;
  margin-bottom: 16px;
  line-height: 26px;
  font-size: 18px;
  font-weight: 600;
  color: #222326;
}
.header-left-mx {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #2469FF;
  text-decoration: none;
  cursor: pointer;
  float: right;
}
.header-left-subtitle {
  margin-bottom: 8px !important;
  line-height: 20px;
  font-size: 14px;
  color: #80858F;
}
.header-left-money {
  line-height: 40px;
  font-size: 32px;
  font-weight: 600;
  color: #222326;
}
.header-left-money-small {
   line-height: 20px;
   font-size: 16px;
   font-weight: 300;
   color: #222326;
 }
.header-left-box-btn {
  margin-top: 30px;
}
.header-left-btn {
  color: #505359;
  line-height: 20px;
  padding: 6px 24px;
  border-radius: 4px;
}
.header-left-btn-red {
  border: 1px solid #FF575C;
  color: #fff;
  background: linear-gradient(279.16deg, #FF242B -0.05%, #FF575C 100%);
  box-shadow: 0px 4px 12px rgba(255, 36, 43, 0.3);
}
.header-left-btn-red:hover {
  background: linear-gradient(279.16deg, #FF4D4D -0.05%, #FF7A75 100%);
}
.header-left-btn-red:active {
  background: linear-gradient(279.16deg, #F52329 -0.05%, #FF242B 100%);
}
.header-right {
  width: 464px;
  height: 100%;
  padding: 24px;
  float: right;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff
}
.header-right-conent {
  padding-bottom: 16px;
  border-bottom: 1px dashed #EEEEF0;
}
.header-right-conent2 {
  padding-top: 16px;
}
.header-right-conent::after,
.header-right-conent2::after {
  content: '';
  display: block;
  height: 0;
  line-height: 0;
  clear: both;
}
.header-right-left,
.header-right-right {
  width: 50%;
  float: left;
}
.header-right-left p:nth-of-type(1),
.header-right-right p:nth-of-type(1) {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #80858F;
}
.header-right-left p:nth-of-type(2),
.header-right-right p:nth-of-type(2) {
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: #222326;
}
.container {
  margin-top: 16px;
  padding: 24px;
  border-radius: 8px;
  background-color: #fff;
}
.container ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.container ul li {
  width: 25%;
  padding-top: 40px;
  padding-bottom: 24px;
  border-radius: 8px;
}
.container ul li:hover {
  transition: all 0.2s;
  /* transform: scale(1, 1.2); */
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, .08);
}

.container ul li img {
  margin: 0 auto;
  display: block;
  margin-bottom: 16px;
}

.container ul li p {
  font-size: 16px;
  text-align: center;
  line-height: 22px;
  padding-bottom: 16px;
}
.container ul li:hover img,
.container ul li:hover p {
  /* transform: scale(1, 1); */
}
.nav-link{
  font-size: 12px;
  color: #4084E8;
  text-decoration: none;
}
.container_title {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
}
.con_btns{
  text-align: center;
  opacity: 0;
}
.container ul li:hover .con_btns {
  opacity: 1;
  transition: all .3s;
}
</style>
